import { EditableDateRangeValue, LabelValue } from '@retail/components';
import dayjs from 'dayjs';
import React from 'react';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  from: Date;
  to: Date;
  onSave?: (purchasePeriodFrom: Date, purchasePeriodTo: Date) => void;
}

export const CampaignPurchasePeriod = ({ from, to, onSave }: Props) => {
  const t = useCampaignTFunction();

  return (
    <LabelValue
      label={t('campaign.purchasePeriod')}
      value={
        <EditableDateRangeValue
          editable={!!onSave}
          renderValue={() => `${dayjs(from).format('ll')} - ${dayjs(to).format('ll')}`}
          onSave={({ startDate, endDate }) => onSave && onSave(startDate, endDate)}
          defaultValue={{
            startDate: from,
            endDate: to,
          }}
        />
      }
      orientation="vertical"
      spacing={0.5}
    />
  );
};
